import { atom } from 'jotai'

export enum FOLLOW_DIALOG_ACTIVE_TAB {
  NONE,
  FOLLOWING,
  FOLLOWERS,
}

export const followDialogActiveTabAtom = atom<FOLLOW_DIALOG_ACTIVE_TAB>(
  FOLLOW_DIALOG_ACTIVE_TAB.NONE
)
